import { ChefHat } from 'lucide-react';

import { Skeleton } from '@/components/ui/skeleton';

export function FullPageLoader() {
  return (
    <div
      className="flex min-h-screen items-center justify-center bg-[rgb(var(--background))]"
      role="status"
      aria-label="Carregando aplicação"
    >
      <div className="w-full max-w-sm space-y-6 p-8 text-center">
        <div className="mx-auto flex size-14 items-center justify-center rounded-2xl bg-brand-600 text-white shadow-lg shadow-brand-500/20">
          <ChefHat className="size-7" />
        </div>
        <div className="space-y-2">
          <Skeleton className="mx-auto h-4 w-40" />
          <Skeleton className="mx-auto h-3 w-28" />
        </div>
      </div>
    </div>
  );
}
